import React, { useEffect } from 'react';
import { Header } from "../components/Header";
import { Box, Typography } from '@mui/material';
import useUserStore from '../store/UserStore';
import { useTranslation } from 'react-i18next';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { STPButton } from '../components/Botones';
import { STPDescription } from '../components/STPDescription';
import L from 'leaflet';
import mapMarker from '../assets/icons/marker-128.png';

// Configurar el icono personalizado
const DefaultIcon = L.icon({
  iconUrl: mapMarker,
  iconSize: [32, 32], // Ajusta el tamaño del icono según sea necesario
  iconAnchor: [16, 32], // Ajusta el ancla del icono según sea necesario
  popupAnchor: [0, -32] // Ajusta el ancla del popup según sea necesario
});

// Aplicar el icono personalizado a todos los marcadores por defecto
L.Marker.prototype.options.icon = DefaultIcon;

export function OnTrobarnos({ setIsAuthenticated }) {
  const { t } = useTranslation();
  const user = useUserStore(state => state.user);

  const handleClick = () => {
    window.open('https://maps.app.goo.gl/Ek4VPazzWsNCxsPe6');
  };

  useEffect(() => {
  }, []);

  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      width: "100%",
    }}>
      <Header setIsAuthenticated={setIsAuthenticated} />

      <Box sx={{ p: 3 }}>
        <Typography variant="h4" sx={{ mb: 4, color: 'black', textAlign: 'center' }}>
          <strong>On ens <span style={{ color: '#50A579' }}>pots trobar</span></strong>
        </Typography>
        <MapContainer center={[41.312672617540066, 2.0082805909286607]} zoom={15} style={{ height: '400px', width: '100%' }}>
          <TileLayer
            attribution='© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={[41.312672617540066, 2.0082805909286607]} icon={DefaultIcon}>
            <Popup>
              Avinguda de Can Batllori, 24
            </Popup>
          </Marker>
        </MapContainer>
        <STPButton variant="contained" onClick={handleClick} sx={{ mt: 5, width: '250px', height: '50px', position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
          Com arribar
        </STPButton>
        <STPDescription mt={16} />
      </Box>
    </Box>
  );
}
